<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <div class="handle-left">
          <el-select
            v-model="location_type"
            style="width: 200px"
            class="handle-select mr10"
          >
            <el-option
              v-for="(child, index) in location_types"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
          <el-input
            v-model="searchTitle"
            class="handle-input mr10"
            placeholder="请输入内容"
          ></el-input>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="handle-add"
            @click="searchBtn"
            >搜索</el-button
          >
        </div>
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add"
          @click="addEdit"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="ID" align="center" width="50">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column
          prop="channel"
          label="渠道"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            {{ format(scope.row.platform_type) }}
          </template>
        </el-table-column>
        <el-table-column label="二维码链接" align="center">
          <template slot-scope="scope">
            {{ scope.row.url }}
            <div>
              <el-button
                type="text"
                @click="downloadByBlob(scope.row.qr_img_url, qrcode)"
                >下载</el-button
              >
              <el-button
                v-show="!disabled"
                type="text"
                @click="openByBlob(scope.row.qr_img_url, short_qrcode)"
                >打开图片</el-button
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="短链二维码链接" align="center">
          <template slot-scope="scope">
            {{ scope.row.short_url }}
            <div>
              <el-button
                v-show="!disabled"
                type="text"
                @click="
                  downloadByBlob(scope.row.short_qr_img_url, short_qrcode)
                "
                >下载</el-button
              >
              <el-button
                v-show="!disabled"
                type="text"
                @click="openByBlob(scope.row.short_qr_img_url, short_qrcode)"
                >打开图片</el-button
              >
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="url"
          label="路径"
          align="center"
          v-if="location_type != 2"
        >
          <template slot-scope="scope">
            {{ scope.row.url }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="route_path"
          label="路由地址"
          align="center"
          v-if="location_type == 3"
        ></el-table-column> -->
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="渠道：" prop="channel">
          <el-input v-model="form.channel"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="location_type">
          <el-select v-model="form.location_type" class="handle-select">
            <el-option
              v-for="(child, index) in location_types"
              :key="index"
              :label="child.label"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="过期时间：" prop="expiredtime">
          <el-date-picker
            v-model="form.expiredtime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="timestamp"
            :picker-options="expireTimeOption"
            @change="beginDateChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/hemeraApiConfig";
import http2 from "../../../api/uploadApiConfig";
import moment from "moment";
import { parseTime } from "./../../../utils/time.js";
export default {
  name: "Qrcode",
  data() {
    return {
      expireTimeOption: {
        disabledDate(time) {
          const dateTime = new Date();
          const startDateTime = dateTime.setDate(dateTime.getDate() - 1);
          return time.getTime() < new Date(startDateTime).getTime();
        },
        selectableRange:
          parseTime(
            new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
            "{hh}:{ii}:{ss}"
          ) + "- 23:59:59",
      },
      disabled: true,
      nowTime: "",
      qrCode_id: "",
      qrcode: "qrcode",
      short_qrcode: "short_qrcode",
      location_types: [
        { label: "家庭中医馆", value: 1 },
        { label: "中医智库", value: 2 },
        // { label: "全部", value: 3 },
      ],
      location_type: 1,
      searchTitle: "",
      topics_type: [],
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      loading: false,
      imageUrl: "",
      multipleSelection: [],
      delList: [],
      editVisible: false,
      is_add: false,
      uploading: false,
      form: {},
      submit_obj: {},
      rules: {
        channel: [{ required: true, message: "请填写渠道", trigger: "blur" }],
        location_type: [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
        expiredtime: [
          { required: true, message: "请选择过期时间", trigger: "blur" },
        ],
      },
      idx: -1,
      id: -1,
    };
  },
  created() {
    this.getData();
  },

  watch: {
    // 禁用此刻之前所有时间
    dataPicker(selectTime) {
      const myDate = new Date();
      const now = myDate.valueOf();
      const time = new Date(selectTime).valueOf();
      if (time > now) {
        this.expireTimeOption.selectableRange =
          parseTime(
            new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
            "00:00:00"
          ) + "- 23:59:59";
      } else {
        this.expireTimeOption.selectableRange =
          parseTime(
            new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
            "{hh}:{ii}:{ss}"
          ) + "- 23:59:00";
      }
    },
  },
  methods: {
    pickerOptions() {
      //如果选择的⽇期为最⼩⽇期，则设置为最⼩⽇期的时分秒
      let str = "";
      if (moment().isSame(moment(this.shopConfig.sellTime), "day")) {
        str = moment().add(1, "H").format("HH:00:00");
      } else {
        str = "00:00:00";
      }

      return {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 3600 * 1000 * 24; // 选当前时间之后的时间
        },
        selectableRange: str + " - 23:59:59",
      };
    },
    beginDateChange(date) {
      if (!date) return;
      var startAt = new Date(date).getTime();
      if (startAt < Date.now()) {
        this.info.beginTime = new Date();
      }
    },
    openByBlob(url) {
      const image = new Image();
      image.src = url;
      image.onload = () => {
        image.style.margin = "0 auto";
        image.style.display = "block";
        const newWin = window.open("", "_blank");
        newWin.document.write(image.outerHTML);
      };
    },
    downloadByBlob(url, name) {
      //第一个参数是图片链接，第二个参数是图片名称
      let image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.src = url;
      image.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        canvas.toBlob((blob) => {
          let url = URL.createObjectURL(blob);
          this.download(url, name);
          // 用完释放URL对象
          URL.revokeObjectURL(url);
        });
      };
    },
    download(href, name) {
      let eleLink = document.createElement("a");
      eleLink.download = name;
      eleLink.href = href;
      eleLink.click();
      eleLink.remove();
    },
    // 搜索
    searchBtn() {
      let that = this;
      console.log(that.location_type, "that.location_type");
      let params = {
        keyword: that.searchTitle,
        platform_type: that.location_type,
        page: that.currentPage,
        page_size: that.page_size,
      };
      http.get("admin/qrcode", { params: params }).then(function (res) {
        that.tableData = res.data.data.items;
        that.currentPage = 1;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    format(type) {
      if (type == "1") {
        return "家庭中医馆";
      } else if (type == "2") {
        return "中医智库";
      }
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    locationTypes(id) {
      var item = _.filter(this.location_types, function (selector) {
        return selector.value == id;
      })[0];
      if (item) {
        return item["label"];
      } else {
        return "";
      }
    },
    topicsType(id) {
      var item = _.filter(this.topics_type, function (selector) {
        return selector.term_id == id;
      })[0];
      if (item) {
        return item["name"];
      } else {
        return "";
      }
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      http.get("admin/qrcode", { params: params }).then(function (res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data.items;
        that.currentPage = res.data.data.page;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
        that.nowTime = Math.round(new Date().getTime() / 1000).toString();
        for (let i = 0; i < that.tableData.length; i++) {
          if (that.tableData[i].expired_at > that.nowTime) {
            that.disabled = false;
          }
        }
        console.log(that.tableData, "that.tableData");
      });
    },
    //选择
    selectHandle() {
      this.currentPage = 1;
      this.getData();
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    //启用操作
    enableEdit(row) {
      // 二次确认删除
      let that = this;
      let params = {
        type: row.type,
        name: row.name,
        img_path: row.img_path,
        url: row.url,
        sub_title: row.sub_title,
        term_id: row.term_id,
        route_path: row.route_path,
      };
      if (row.enable) {
        params["enable"] = 0;
        that
          .$confirm("是否关闭启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/health/" + row.id, params).then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("关闭成功");
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        params["enable"] = 1;
        that
          .$confirm("是否启用?", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("admin/health/" + row.id, params).then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("启用成功");
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    beforeAvatarUpload(file) {
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        ossData.append("work_path", "common/findpage");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function (res) {
          if (res.data.status_code == 200) {
            that.imageUrl = "common/findpage/" + filename;
            that.form.img_path = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 删除操作
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("admin/health/" + row.id).then(function (res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 多选操作
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onInput() {
      this.$forceUpdate();
    },
    // 编辑操作
    handleEdit(row) {
      this.form = {
        channel: row.channel,
        location_type: this.location_type,
      };
      this.qrCode_id = row.id;
      this.is_add = false;
      this.editVisible = true;
    },
    //新增操作
    addEdit() {
      this.form = {
        channel: "",
        platform_type: this.location_type,
        expiredtime: "",
        remark: "",
      };
      this.is_add = true;
      this.editVisible = true;
    },
    // 保存编辑
    saveEdit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            channel: that.form.channel,
            platform_type: that.form.location_type,
            expiredtime: that.form.expiredtime / 1000,
            remark: that.form.remark,
          };
          if (that.is_add) {
            http.post("admin/qrcode", params).then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success(`新增成功`);
                that.getData();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          } else {
            http
              .put("admin/qrcode/" + that.qrCode_id, params)
              .then(function (res) {
                // console.log(res);
                if (res.data.status_code == 200) {
                  that.$message.success(`修改成功`);
                  that.getData();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
          }
          that.editVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
.avatar {
  height: 178px;
  display: block;
  max-width: 100%;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
